import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class TrackerState extends Vue {
  @Prop({ default: '' }) stateName!: String

  @Getter getCurrentOrder: any

  get markStatus () {
    let mark
    if (this.getCurrentOrder.status === this.stateName) {
      mark = true
    }
    if (this.getCurrentOrder.logs) {
      for (let i = 0; i < this.getCurrentOrder.logs.length; i++) {
        const element = this.getCurrentOrder.logs[i].to
        if (this.stateName === element) {
          mark = true
        }
      }
    }
    return mark
  }

  get setText () {
    switch (this.stateName) {
      case 'order_not_generated':
        return this.$t(`order_not_generated.message`)
      case 'waiting_for_external_payment':
        return this.$t(`waiting_for_external_payment.message`)
      case 'waiting_restaurant_confirmation':
        return this.$t(`waiting_restaurant_confirmation.message`)
      case 'preparing_order':
        return this.$t(`preparing_order.message`)
      case 'waiting_pickup_deliveryman':
        return this.$t(`waiting_pickup_deliveryman.message`)
      case 'waiting_pickup_client':
        return this.$t(`already_restaurant.message`)
      case 'delivering_order':
        return this.$t(`delivering_order.message`)
      case 'order_completed':
        return this.$t(`order_completed.message`)
      case 'troubleshooting_restaurant':
        return this.$t(`troubleshooting_restaurant.message`)
      case 'troubleshooting_deliveryman':
        return this.$t(`troubleshooting_deliveryman.message`)
      case 'troubleshooting_hand_off':
        return this.$t(`troubleshooting_hand_off.message`)
      case 'order_canceled_by_restaurant':
        return this.$t(`order_canceled_by_restaurant.message`)
      case 'order_canceled_in_handoff':
        return this.$t(`order_canceled_in_handoff.message`)
      case 'order_canceled_by_troubleshooting_delivery_man':
        return this.$t(`order_canceled_by_troubleshooting_delivery_man.message`)
    }
  }

  get setStateName () {
    let status
    switch (this.stateName) {
      case 'order_not_generated':
        status = {
          title: this.$t(`order_not_generated.state`),
          icon: '😟'
        }
        return status
      case 'waiting_for_external_payment':
        status = {
          title: this.$t(`waiting_for_external_payment.state`),
          icon: '👂'
        }
        return status
      case 'waiting_restaurant_confirmation':
        status = {
          title: this.$t(`waiting_restaurant_confirmation.state`),
          icon: '✏️'
        }
        return status
      case 'preparing_order':
        status = {
          title: this.$t(`preparing_order.state`),
          icon: '👍🏼'
        }
        return status
      case 'waiting_pickup_deliveryman':
        status = {
          title: this.$t(`already_restaurant.state`),
          icon: '🚀'
        }
        return status
      case 'waiting_pickup_client':
        status = {
          title: this.$t(`already_restaurant.state`),
          icon: '🍴'
        }
        return status
      case 'delivering_order':
        status = {
          title: this.$t(`delivering_order.state`),
          icon: '🏃🏻‍♂'
        }
        return status
      case 'order_completed':
        status = {
          title: this.$t(`order_completed.state`),
          icon: '👌'
        }
        return status
      case 'troubleshooting_restaurant':
        status = {
          title: this.$t(`troubleshooting_restaurant.state`),
          icon: '😨'
        }
        return status
      case 'troubleshooting_deliveryman':
        status = {
          title: this.$t(`troubleshooting_deliveryman.state`),
          icon: '😨'
        }
        return status
      case 'troubleshooting_hand_off':
        status = {
          title: this.$t(`troubleshooting_hand_off.state`),
          icon: '😨'
        }
        return status
      case 'order_canceled_by_restaurant':
        status = {
          title: this.$t(`order_canceled_by_restaurant.state`),
          icon: '😟'
        }
        return status
      case 'order_canceled_in_handoff':
        status = {
          title: this.$t(`order_canceled_in_handoffstatee.${this.getCurrentOrder.commerce.type}`),
          icon: '😟'
        }
        return status
      case 'order_canceled_by_troubleshooting_delivery_man':
        status = {
          title: this.$t(`order_canceled_by_troubleshooting_delivery_man.state`),
          icon: '😟'
        }
        return status
      default:
        status = {
          title: 'Estado no definido',
          icon: '🤪'
        }
        return status
    }
  }
}
